import { render, staticRenderFns } from "./JobList.vue?vue&type=template&id=ab38bbc0&"
import script from "./JobList.vue?vue&type=script&lang=js&"
export * from "./JobList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab38bbc0')) {
      api.createRecord('ab38bbc0', component.options)
    } else {
      api.reload('ab38bbc0', component.options)
    }
    module.hot.accept("./JobList.vue?vue&type=template&id=ab38bbc0&", function () {
      api.rerender('ab38bbc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwg/js/components/JobList.vue"
export default component.exports